<template>
  <div class="modal" :class="{'is-active': settings.active}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p v-if="activePalette" class="modal-card-title">
          {{activePalette.title()}}
        </p>
        <button class="delete" @click="cancel"></button>
      </header>
      <section class="modal-card-body">
        <fill v-if="isFill" ref="fill" :settings="settings.fill"></fill>
        <border v-if="isBorder" ref="border" :settings="settings.border" :line="isLine"></border>
        <text-options v-if="isText" ref="text" :settings="settings.text"></text-options>
      </section>
      <footer class="modal-card-foot">
        <div>
          <a class="button is-primary" @click="ok">{{ $t("ok") }}</a>
          <a class="button" @click="cancel">{{ $t("cancel") }}</a>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Fill from './Fill'
import Border from './Border'
import TextOptions from './Text'
// import i18n from '@/i18n'

export default {
  components: {
    Fill,
    Border,
    TextOptions
  },
  props: ['settings', 'update', 'close'],
  data: function () {
    return {
      activePalette: null
    }
  },
  computed: {
    isFill: function () {
      return this.settings.mode === 'fill' && this.settings.supportsFill
    },
    isBorder: function () {
      return this.settings.mode === 'border' || (this.settings.mode === 'fill' && !this.settings.supportsFill)
    },
    isText: function () {
      return this.settings.mode === 'text'
    },
    isLine: function () {
      return !this.settings.supportsFill && this.settings.supportsBorder
    }
  },
  mounted: function () {
    this.colour = this.settings.fill.colour
    this.noFill = this.settings.fill.none

    if (this.isFill) {
      this.activePalette = this.$refs.fill
    } else if (this.isBorder) {
      this.activePalette = this.$refs.border
    } else if (this.isText) {
      this.activePalette = this.$refs.text
    }

    this.loaded = true
  },
  methods: {
    ok: function () {
    //   this.settings.fill.colour = this.colour
    //   this.settings.fill.none = this.noFill
      this.activePalette.update()
      this.update(this.settings)
      this.cancel()
    },
    cancel: function () {
    //   this.colour = null
    //   this.noFill = false
    //   this.settings.active = false
      this.settings.active = false
      this.loaded = false
      this.activePalette = null
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .modal-card-body {
    padding: 2%;
  }
</style>
